import type { IAttachment } from 'src/stores/JobApplicationStore/Attachment';

/**
 * sort by type first: resume, cover letter, selection criteria, hirer uploaded
 * then sort by uploadedDate asc
 */
export const sortStoreAttachments = (
  attachments: IAttachment[],
): IAttachment[] =>
  [...attachments].sort((a, b) => {
    if (a.type === b.type) {
      return (a.uploadedDate || '').localeCompare(b.uploadedDate || '');
    }
    return a.type - b.type;
  });
